module.exports = __webpack_public_path__ + "img/zuckerberg_christmas.4d0fd8e9.png";